<template>
  <section id="wrapper" class="error-page">
    <div class="error-box">
      <div class="error-body text-center">
        <h1 class="text-info">404</h1>
        <h3 class="text-uppercase">Not Found</h3>
        <p class="text-muted m-t-30 m-b-30">該当の情報またはページが見つかりませんでした。</p>
        <a href="/" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">ホームへ戻る</a>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>

</style>
